var map = {
	"./KOLORO_1681114321927.jpg": 577,
	"./KOLORO_1681410180368.png": 70,
	"./KOLORO_1681411313195.png": 547,
	"./KOLORO_1681411586896.png": 249,
	"./WhatsApp Image 2024-03-04 at 12.26.25.jpeg": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 645;